/**
 * Admin Configuration
 * 
 * This file contains the pubkeys of users who have admin access to the platform.
 * Only these users can access the dashboard and see user registrations.
 */

// Admin pubkeys (hex format)
export const ADMIN_PUBKEYS = [
  // BitcoinLifePanamá - Main admin
  'ec4acaa5029a201e069afa51a71f59e231d97dd3bfe06eabcd605690252c34ae',
  
  // Add more admin pubkeys here:
  // 'another_admin_pubkey_in_hex_format',
];

/**
 * Check if a pubkey has admin access
 * @param pubkey - The pubkey to check (hex format)
 * @returns true if the pubkey is an admin
 */
export const isAdminPubkey = (pubkey: string | undefined): boolean => {
  if (!pubkey) return false;
  return ADMIN_PUBKEYS.includes(pubkey);
};
